import { Component, Input, Output, EventEmitter, ElementRef, Renderer, OnInit } from '@angular/core';
import { CommonNotificationService } from '../../services/common-notification.service';
import { BaseWidgetComponent } from '../base-widget.component';

@Component({
    selector: 'custom-fab',
    templateUrl: './custom-fab.component.html',
    styleUrls: ['./custom-fab.component.scss']
})
export class CustomFabComponent extends BaseWidgetComponent implements OnInit {
    fabIcon: string;
    disabled: boolean = false;
    hideFab: boolean = true;
    fabType: CustomFabType = CustomFabType.Standard;
    fabText: string = '';

    @Input('fab-color') fabColor: string;

    constructor(private commonNotificationService: CommonNotificationService) {
        super();
        this.commonNotificationService.$disableFabSource.takeUntil(this.emitUnsubscribe).subscribe(
            (flag: boolean) => {
                this.disabled = flag;
            });
        this.commonNotificationService.$fabIconSource.takeUntil(this.emitUnsubscribe).subscribe(
            (icon: string) => {
                this.fabIcon = icon;
            });
        this.commonNotificationService.$hideFabSource.takeUntil(this.emitUnsubscribe).subscribe(
            (flag: boolean) => {
                this.hideFab = flag;
            });
        this.commonNotificationService.$fabTypeSource.takeUntil(this.emitUnsubscribe).subscribe(
            (fab: ICustomFab) => {
                this.fabType = fab.Type;
                this.fabText = fab.Text;
            }
        );
    }

    ngOnInit() { }

    onClickFab = () => {
        this.commonNotificationService.emitOnClickFab(this.fabIcon);
    }
}

export enum CustomFabType {
    Standard = 0,
    RaisedButton = 1,
    NoIconRaisedButton = 2,
}

export interface ICustomFab {
    Type: CustomFabType;
    Text: string;
}



// WEBPACK FOOTER //
// ./src/app/widgets/custom-fab/custom-fab.component.ts